import { c as createFormat, e as extend, a as createCustomFormatFn, b as createParse, d as defaultFormatters, f as defaultParsers, p as parseOrThrowWrapper } from '../../default-parsers-50f9e074.js';
export { k as addDate, j as addHours, g as addMilliseconds, i as addMinutes, l as addMonth, h as addSeconds, m as addYear, T as asValidDateOrNull, E as diffCalendarDate, D as diffCalendarMonth, C as diffCalendarYear, z as diffDate, y as diffHours, v as diffMilliseconds, x as diffMinutes, A as diffMonth, I as diffPreciseDate, H as diffPreciseHours, G as diffPreciseMinutes, J as diffPreciseMonth, F as diffPreciseSeconds, K as diffPreciseYear, w as diffSeconds, B as diffYear, L as formatDateIso, M as formatDateTimeIso, N as formatLocalIso, R as fromDate, S as fromDateOrThrow, Q as isValidDate, U as newValidDate, V as newValidDateOrThrow, O as parseIso, P as parseIsoOrThrow, q as resetDate, s as resetHours, o as resetISOWeek, t as resetMinutes, n as resetMonth, u as resetSeconds, r as resetYear } from '../../default-parsers-50f9e074.js';

// Note: in Danish, the names of days of the week and months are lowercased.
var months3char = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
var monthsFull = [
    'januar',
    'februar',
    'marts',
    'april',
    'maj',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'december',
];
var weekdays2char = ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'];
var weekdays3char = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];
var weekdaysFull = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
var meridiemUppercase = ['AM', 'PM'];
var meridiemLowercase = ['am', 'pm'];
var meridiemFull = ['a.m.', 'p.m.'];
var formatters = {
    // Month: jan, feb, ..., dec
    MMM: function (date) { return months3char[date.getMonth()]; },
    // Month: januar, februar, ..., december
    MMMM: function (date) { return monthsFull[date.getMonth()]; },
    // Day of week: sø, ma, ..., lø
    dd: function (date) { return weekdays2char[date.getDay()]; },
    // Day of week: søn, man, ..., lør
    ddd: function (date) { return weekdays3char[date.getDay()]; },
    // Day of week: søndag, mandag, ..., lørdag
    dddd: function (date) { return weekdaysFull[date.getDay()]; },
    // AM, PM
    A: function (date) { return meridiemUppercase[date.getHours() < 12 ? 0 : 1]; },
    // am, pm
    a: function (date) { return meridiemLowercase[date.getHours() < 12 ? 0 : 1]; },
    // a.m., p.m.
    aa: function (date) { return meridiemFull[date.getHours() < 12 ? 0 : 1]; },
    Mo: ordinalFormatter('M'),
    Do: ordinalFormatter('D'),
    DDDo: ordinalFormatter('DDD'),
    do: ordinalFormatter('d'),
    Qo: ordinalFormatter('Q'),
    Wo: ordinalFormatter('W'),
};
// Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
function ordinalFormatter(formatterToken) {
    return function (date) { return ordinal(defaultFormatters[formatterToken](date)); };
}
function ordinal(number) {
    return number + '.';
}
function toLower(s) {
    return s.toLowerCase();
}
var months3charLower = months3char.map(toLower);
var monthsFullLower = monthsFull.map(toLower);
var parsers = {
    // Month: jan, feb, ..., dec
    MMM: [
        months3charLower.join('|'),
        function (date, value) {
            var index = months3charLower.indexOf(value.toLowerCase());
            date.setMonth(index);
        },
    ],
    // Month: januar, februar, ..., december
    MMMM: [
        monthsFullLower.join('|'),
        function (date, value) {
            value = value.toLowerCase();
            var index = monthsFullLower.indexOf(value);
            date.setMonth(index);
        },
    ],
    Mo: ordinalParser('M'),
    Do: ordinalParser('D'),
    DDDo: ordinalParser('DDD'),
    do: ordinalParser('d'),
    Qo: ordinalParser('Q'),
    Wo: ordinalParser('W'),
};
// Generate ordinal version of parsers: M -> Mo, D -> Do, etc.
function ordinalParser(token) {
    return [
        '\\d+(?:[.])',
        function (date, value) {
            defaultParsers[token][1](date, value.slice(0, -1));
        },
    ];
}
var format = createFormat(extend(defaultFormatters, formatters));
var createCustomFormat = createCustomFormatFn(extend(defaultFormatters, formatters));
var parse = createParse(extend(defaultParsers, parsers));
var parseOrThrow = parseOrThrowWrapper(parse);

export { createCustomFormat, format, formatters, parse, parseOrThrow };
